/* ======================================================================
   ET — Cart drawer (AB test: cart_003_2) — VARIANT (v2) behaviour
   Initialises the "complete with" Swiper slider for the redesign.

   INTELLIGEMS A/B GATE
   --------------------
   Only runs when the variant is active, i.e. the `ig-cd-v2` class is on
   <html> or <body> (added by Intelligems for the variant group). Because
   Intelligems may add that class after this script runs, we also watch
   the <html>/<body> class list and initialise as soon as it appears.

   The cart drawer re-renders its whole markup on every cart change, which
   destroys any live Swiper instance and injects fresh DOM, so we also
   re-initialise on the theme's `cart-drawer:refreshed` event.
   ====================================================================== */
(function () {
  var SLIDER_SELECTOR = '[data-cart-upsell-swiper]';
  var VARIANT_CLASS = 'ig-cd-v2';
  var instances = [];

  function isVariant() {
    return (
      document.documentElement.classList.contains(VARIANT_CLASS) ||
      document.body.classList.contains(VARIANT_CLASS)
    );
  }

  function destroyAll() {
    instances.forEach(function (swiper) {
      try {
        if (swiper && !swiper.destroyed) {
          swiper.destroy(true, true);
        }
      } catch (e) {}
    });
    instances = [];
  }

  function initSliders() {
    if (!isVariant() || typeof Swiper === 'undefined') return;

    document.querySelectorAll(SLIDER_SELECTOR).forEach(function (el) {
      if (el.classList.contains('swiper-initialized')) return;

      var wrap = el.closest('.et-cd-upsells');
      var pagination = wrap ? wrap.querySelector('[data-cart-upsell-pagination]') : null;

      var swiper = new Swiper(el, {
slidesPerView: 2.5,
spaceBetween: 12,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        a11y: { enabled: true },
        pagination: pagination
          ? { el: pagination, clickable: true }
          : false,
breakpoints: {
  700: {
    slidesPerView: 3,
    spaceBetween: 12
  }
}
      });

      instances.push(swiper);
    });
  }

  function boot() {
    initSliders();

    /* Intelligems may flip the variant class after load — watch for it. */
    if (!isVariant() && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        if (isVariant()) {
          observer.disconnect();
          initSliders();
        }
      });
      observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Cart drawer re-rendered → old DOM (and Swiper) gone; rebuild. */
  document.addEventListener('cart-drawer:refreshed', function () {
    destroyAll();
    initSliders();
  });

  /* Drawer became visible → recompute slide widths (it may have been
     initialised while hidden with a zero-width container). */
  document.addEventListener('dialog:after-show', function () {
    instances.forEach(function (swiper) {
      if (swiper && !swiper.destroyed && typeof swiper.update === 'function') {
        swiper.update();
      }
    });
  });
})();
